import { MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import { FC } from "react";
import { ItalianStoryResponseTo } from "../../../models/italianStory";
import styles from "../../../styles/italianStory/ItalianStory.module.scss";
import { copyToClipboard } from "../../../utils/common";
import Btn from "../../common/Btn";
import SocialBtn, { TSocialIcon } from "../../common/SocialBtn";
import ItalianStory from "./ItalianStory";
import ItaliaStoryTitle from "./ItaliaStoryTitle";
import PublishedDate from "./PublishedDate";

const ItalianStoryArticle: FC<{
    italianStory: ItalianStoryResponseTo;
}> = ({ italianStory }) => {
    const { title, stories, author, time, date, tags, avatar, colorAvatar } =
        italianStory;

    const arrStories = (
        <div className={styles.italianStoryBodyStories}>
            {!!stories &&
                stories.map(story => (
                    <ItalianStory article={story} className="mt-5" />
                ))}
        </div>
    );

    // const socials: TSocialIcon[] = ["TwitterLine", "FacebookLine"];
    const socials: TSocialIcon[] = ["FacebookLine"];

    return (
        <MDBContainer
            fluid
            className={`d-flex flex-column justify-content-center align-items-center ${styles.italianStoryBody}`}
        >
            <div
                className={`d-flex flex-column justify-content-center ${styles.italianStoryBodyContent}`}
            >
                <ItaliaStoryTitle
                    text={title}
                    author={author}
                    tags={tags}
                    readTime={time}
                    avatar={avatar}
                    colorAvatar={colorAvatar}
                />
                {arrStories}
                <MDBRow>
                    <MDBCol center size={12} md={6}>
                        {!!date && (
                            <PublishedDate
                                className={`d-flex text-start align-items-center ${styles.italianStoryBodyPublishedDate}`}
                                date={date}
                            />
                        )}
                    </MDBCol>
                    <MDBCol size={12} md={6}>
                        <div className="d-flex justify-content-between justify-content-md-end align-items-top mt-4 mt-md-0">
                            <Btn
                                className="me-3"
                                onClick={async () =>
                                    copyToClipboard(window.location.href)
                                }
                            >
                                Copy link
                            </Btn>
                            <div>
                                {socials.map(social => (
                                    <SocialBtn key={social} social={social} />
                                ))}
                            </div>
                        </div>
                    </MDBCol>
                </MDBRow>
            </div>
        </MDBContainer>
    );
};

export default ItalianStoryArticle;
